const sortingArr = [
  'a',
  'k',
  'q',
  'j',
  'number_9',
  'number_8',
  'number_7',
  'number_6',
  'number_5',
  'number_4',
  'number_3',
  'number_2',
  'joker',
];

export const orderStatisticsCards = (statisticsData) =>
  statisticsData.sort((a, b) => sortingArr.indexOf(a.name) - sortingArr.indexOf(b.name));
